"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ProfileMenu_1 = __importDefault(require("./ProfileMenu"));
exports.default = ProfileMenu_1.default;
